import logoLight from '../assets/images/logo_light.png';
import logoDark from '../assets/images/LOGO CEDI 2022 - MAX V1.svg';
import notificationsIcon from '../assets/images/notifications_icon.png';
import calenderIcon from '../assets/images/calender_icon.png';
import listIcon from '../assets/images/list_icon.png';
import cubeIcon from '../assets/images/cube_icon.png';
import menuIcon from '../assets/images/menu_icon.png';
import userIcon from '../assets/images/user_icon.png';
import closeIcon from '../assets/images/close_icon.png';
import OffcanvasMenu from './OffcanvasMenu/OffcanvasMenu';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';

export default function Navbar({ pageTitle }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);

    const user = localStorage.getItem('user');
    const userObject = JSON.parse(user);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    // Rileva i clic all'esterno del menu
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                closeMenu();
            }
        };

        if (menuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuOpen]);

    return (
        <header className="flex flex-wrap sm:justify-start sm:flex-nowrap static fixed bg-white top-0 left-0 w-full text-sm z-50">
            <nav className="mx-auto w-full pl-2 sm:pl-0 sm:flex sm:items-center  sm:justify-between" aria-label="Global">
                <div className="flex items-stretch justify-between w-full">
                    <Link className="flex-none" to="/">
                        <img className="w-[100px] h-auto object-fit" src={logoDark} alt="CEDI" />
                    </Link>
                    <div className="flex items-center px-5 border-solid sm:border-transparent">
                        <a onClick={toggleMenu} className="font-medium text-neutral-400 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600" href="#" aria-current="page">
                            <span className="material-symbols-outlined text-4xl" translate="no">menu</span>
                        </a>
                    </div>
                </div>
            </nav>

            <div
                ref={menuRef}
                id="hs-overlay-example"
                className={`overflow-auto hs-overlay transition-all duration-300 transform h-full max-w-xs w-full z-[99999] bg-white border-s fixed top-0 end-0 ${
                    menuOpen ? 'translate-x-0' : 'translate-x-full'
                }`}
                tabIndex={-1}
            >
                <div className="flex justify-between items-center py-3 px-4 border-b border-neutral-200">
                    <Link to="/user-profile" className="flex items-center gap-5 font-bold text-gray-800 hover:text-blue-500 transition-colors">
                        <span className="text-2xl text-center w-8 h-auto text-white bg-neutral-300 rounded-full material-symbols-outlined" translate="no">person</span>
                        <h4 className="text-lg font-light text-neutral-600">{userObject?.firstName} {userObject?.lastName}</h4>
                    </Link>
                    <span onClick={closeMenu} className="text-4xl cursor-pointer material-symbols-outlined text-neutral-400" translate="no">close</span>
                </div>
                <OffcanvasMenu onClose={closeMenu} />
            </div>
        </header>
    );
}
